<template>
  <div class="bg-white py-2 px-2">
    <div class="flex justify-end">
      <v-icon @click="close_dialog"> mdi-close</v-icon>
    </div>
    <div class="text-center my-2 font-bold">NOTIFICATION</div>
    <div class="px-4 mb-4">
      <div class="border-b-2 border-gray-400">
        <div class="flex">
          <div class="mr-2">Date:</div>
          <div>
            {{ momentFormat(email_content.reg_date) }}
          </div>
        </div>
        <div class="flex">
          <div class="mr-2">Subject:</div>
          <div>
            {{ email_content.subject }}
          </div>
        </div>
      </div>
      <div
        class="my-2 bg-gray-100 p-2 leading-3"
        v-html="email_content.content"
      ></div>
      <div>
        <h3 class="border-b-2 border-gray-400">Attachments</h3>
        <div
          v-for="(signedUrl, i) in signedAttachments"
          :key="i"
          style="width: 500px; height: 500px"
        >
          <iframe :src="signedUrl" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import supabase from "../../../../supabase";

export default {
  props: ["email_content"],
  data() {
    return {
      attachments: [],
      signedAttachments: [],
    };
  },
  methods: {
    /**
     * Asynchronously creates a signed URL for the given attachment path.
     */
    async getAttachmentUrl(attachmentPath) {
      // Extract the filename from the attachment path
      const fileName = attachmentPath.split("/").pop();
      // Provide the expiresIn parameter (in seconds)
      const { data } = await supabase.storage
        .from("data")
        .getPublicUrl(fileName);
      return data.publicUrl;
      // return `${process.env.VUE_APP_SERVER_URL}/data/uploads/${fileName}`;
    },

    close_dialog() {
      this.$emit("close_dialog");
    },

    momentFormat(f) {
      return moment(f).format("LLL");
    },

    /**
     * Loads all attachments and converts each to its signed URL.
     */
    async loadSignedAttachments() {
      if (this.email_content.attachments) {
        this.attachments = this.email_content.attachments.split(",");
        // Use Promise.all to fetch all signed URLs and update our data property
        this.signedAttachments = await Promise.all(
          this.attachments.map((path) => this.getAttachmentUrl(path))
        );
      }
    },
  },
  watch: {
    email_content: {
      handler() {
        this.loadSignedAttachments();
      },
      immediate: true,
    },
  },
};
</script>
